module.exports = __webpack_public_path__ + "2e09ad8549d7508119b9e8c29a472768.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/public/fonts/Work_Sans/WorkSans-Medium.woff2
// module id = 1815
// module chunks = 1